import { render, staticRenderFns } from "./RegisterWindow.vue?vue&type=template&id=681ecfc3&"
import script from "./RegisterWindow.vue?vue&type=script&lang=js&"
export * from "./RegisterWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681ecfc3')) {
      api.createRecord('681ecfc3', component.options)
    } else {
      api.reload('681ecfc3', component.options)
    }
    module.hot.accept("./RegisterWindow.vue?vue&type=template&id=681ecfc3&", function () {
      api.rerender('681ecfc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/MblManagement/components/RegisterWindow.vue"
export default component.exports